module.exports = __webpack_public_path__ + "static/media/2021 Voiceover Script Awards Video_1627869320776.bfb8b8be.docx";